module.exports = __webpack_public_path__ + "static/media/program illustration.12a9c354.PNG";